import React from "react";


class Disclaimer extends React.Component {
    render() {
        return (
            <>
                <h3>
                    Disclaimer for Machine Learning Practices
                </h3>
                <p className="simple-text-md" >
                    If you require any more information or have any questions about our site's disclaimer, please feel free to contact me by email at htanloc994@gmail.com
                </p><p className="simple-text-md" >
                    Disclaimers for Machine Learning Practices
                    All the information on this website is published in good faith and for general information purpose only. Website Name does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website (machinelearningpractices.com), is strictly at your own risk. will not be liable for any losses and/or damages in connection with the use of our website.
                </p>
                <p className="simple-text-md" >From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone ‘bad'.
                </p>
                <p className="simple-text-md" >
                    Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.
                </p>
                <p className="simple-text-md" >
                    Consent
                    By using our website, you hereby consent to our disclaimer and agree to its terms.
                </p >
                <p className="simple-text-md">Update Should we update, amend or make any changes to this document, those changes will be prominently posted here.</p>

            </>
        )
    }
}

export default Disclaimer;